// extracted by mini-css-extract-plugin
export default {"main":"Products_main__zWBpc","navCatalogo":"Products_navCatalogo__s26MX"};